import { render, staticRenderFns } from "./manufactureruserlist.vue?vue&type=template&id=0485249a&scoped=true"
import script from "./manufactureruserlist.vue?vue&type=script&lang=js"
export * from "./manufactureruserlist.vue?vue&type=script&lang=js"
import style0 from "./manufactureruserlist.vue?vue&type=style&index=0&id=0485249a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485249a",
  null
  
)

export default component.exports